import { z } from 'zod';

import { RoleSchema } from './role';

export const UserSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  active: z.boolean(),
  lastLogin: z.date().optional(),
  role: RoleSchema.pick({ id: true, name: true }),
});

export type User = z.infer<typeof UserSchema>;
